import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { Nav } from "react-bootstrap";

import settings from "../../assets/settings.svg";
import edit from "../../assets/edit.svg";
import users from "../../assets/users.svg";

import "./sidebar.styles.scss";
import Navitem from "../nav-item/nav-item.component";

const Sidebar = () => {
  const history = useHistory();
  const location = useLocation();
  const [exists, setExists] = useState("initial");
  const organizations = useSelector(
    (state) => state.organization.allOrganizations
  );

  useEffect(() => {
    if (location.pathname.includes("/settings")) setExists(true);
    else setExists(false);
  }, [organizations, location.pathname]);
  return (
    <>
      {exists ? (
        <Nav className="sidebar-container">
          <div className="sidebar-sticky">
            <div className="settings-sidebar-parent">
              <Navitem
                current={history.location.pathname === "/settings/manageusers"}
                onClick={() => history.push("/settings/manageusers")}
              >
                <img className="user-image" src={users} alt="" />
                Manage Users
              </Navitem>
              <Navitem
                current={
                  history.location.pathname === "/settings/admin-questionnaire"
                }
                onClick={() => history.push("/settings/admin-questionnaire")}
              >
                <img src={edit} alt="" />
                Edit Survey
              </Navitem>
              <Navitem
                current={history.location.pathname === "/settings/preferences"}
                onClick={() => history.push("/settings/preferences")}
              >
                <img src={settings} alt="" />
                Manage Dimensions
              </Navitem>
              <Navitem
                current={
                  history.location.pathname === "/settings/score-preferences"
                }
                onClick={() => history.push("/settings/score-preferences")}
              >
                <i className="fas fa-star"></i>Score Preferences
              </Navitem>
              <Navitem
                eventKey="1"
                current={history.location.pathname === "/settings/resubmission"}
                onClick={() => history.push("/settings/resubmission")}
              >
                <i className="fas fa-repeat"></i>Resubmit Assessments
              </Navitem>
              <Navitem
                current={history.location.pathname === "/settings/usage"}
                onClick={() => history.push("/settings/usage")}
              >
                <i className="fas fa-info-circle"></i>Usage Details
              </Navitem>
              <Navitem
                current={history.location.pathname === "/settings/phone-survey"}
                onClick={() => history.push("/settings/phone-survey")}
              >
                <i className="fas fa-phone"></i>Phone Survey
              </Navitem>
              <Navitem
                current={history.location.pathname === "/settings/phone-call-history"}
                onClick={() => history.push("/settings/phone-call-history")}
              >
                <i className="fas fa-phone-alt"></i>Phone Call History
              </Navitem>
              <Navitem
                current={history.location.pathname === "/settings/incoming-calls"}
                onClick={() => history.push("/settings/incoming-calls")}
              >
                <i className="fas fa-inbox"></i>Incoming Calls
              </Navitem>
              <Navitem
                current={history.location.pathname === "/settings/phone-lines"}
                onClick={() => history.push("/settings/phone-lines")}
              >
                <i className="fas fa-tty"></i>Phone Numbers
              </Navitem>
              <Navitem
                current={history.location.pathname === "/settings/email-history"}
                onClick={() => history.push("/settings/email-history")}
              >
                <i className="fas fa-envelope"></i>Email History
              </Navitem>
              <Navitem
                current={history.location.pathname === "/settings/email-templates"}
                onClick={() => history.push("/settings/email-templates")}
              >
                <i className="fas fa-file-alt"></i>Email Templates
              </Navitem>
              <Navitem
                current={history.location.pathname === "/settings/ses"}
                onClick={() => history.push("/settings/ses")}
              >
                <i className="fas fa-cloud"></i>Amazon SES Settings
              </Navitem>
            </div>
          </div>
        </Nav>
      ) : (
        ""
      )}
    </>
  );
};

export default Sidebar;
